import { resaltarTramos } from '../../utils/highlighting';

/**
 * Texto con los términos buscados en `<mark>`, armado con nodos de React (nunca HTML): lo que venga en el título o
 * en el contenido del documento se muestra como texto aunque traiga etiquetas.
 */
export default function Resaltado({ texto, consulta, marca = 'bg-amber-100/90 text-slate-900 px-0.5 rounded-xs' }: { texto: string; consulta?: string; marca?: string }) {
  const tramos = resaltarTramos(texto, consulta || '');
  return (
    <>
      {tramos.map((t, i) =>
        t.resaltado ? (
          <mark key={i} className={marca}>{t.texto}</mark>
        ) : (
          <span key={i}>{t.texto}</span>
        )
      )}
    </>
  );
}
